import type { ModuleKey } from './modules';

/**
 * app_settings היא טבלת key/value של jsonb (PRD, נספח ב).
 * כאן ממפים את המפתחות לאובייקט מוקלד אחד.
 * המיתוג כולו מההגדרות: אין שם לקוח, צבע או כתובת בקוד (PRD 2.10).
 */
export type Brand = {
  name: string;
  app_title: string;
  primary_color: string | null;
  accent_color: string | null;
  /** נתיב בבדלי brand או URL מלא. כשאין, נופלים לקבצים שב public/brand. */
  logo_white: string | null;
  logo_ink: string | null;
  /** אייקוני ההתקנה. כשאין, נופלים לאייקונים שנבנו מהלוגו. */
  icon_192: string | null;
  icon_512: string | null;
};

export type AppSettings = {
  brand: Brand;
  modules: Record<ModuleKey, boolean>;
  timezone: string;
  appUrl: string;
  /** כל ההגדרות כפי שהן בטבלה, לקריאה ישירה לפי מפתח. */
  raw: Record<string, unknown>;
};

/** עד שההגדרות נטענות: בלי שם לקוח, בלי צבע קשיח. */
export const FALLBACK_BRAND: Brand = {
  name: '',
  app_title: 'אפליקציית העובדים',
  primary_color: null,
  accent_color: null,
  logo_white: null,
  logo_ink: null,
  icon_192: null,
  icon_512: null,
};
